export const DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID = 'dash-recent-activations'

export const DASH_RECENT_ACTIVATIONS_GRID_CONFIG = {
  id: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID,
  layout: {
    xl: { i: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID, x: 0, y: 3, w: 4.95, h: 3, static: true },
    lg: { i: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID, x: 3, y: 3, w: 6, h: 3, static: true },
    md: { i: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID, x: 5, y: 3, w: 7, h: 3, static: true },
    sm: { i: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID, x: 0, y: 6, w: 12, h: 3, static: true },
    xs: { i: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID, x: 0, y: 7.25, w: 12, h: 1.75, static: true },
    xxs: { i: DASH_RECENT_ACTIVATIONS_GRID_CONFIG_ID, x: 0, y: 6.45, w: 12, h: 1.75, static: true }
  }
}
